<template>
  <div class="vx-row">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="closeFarmSidebar"
      :data="sidebarData"
    />
    <expenses-data-view-sidebar
      :isSidebarActive="addNewExpenseSidebar"
      @closeSidebar="closeExpensesSidebar"
      :data="expenseSidebarData"
    />

    <harvests-data-view-sidebar
      :isSidebarActive="addNewHarvestSidebar"
      @closeSidebar="closeHarvestsSidebar"
      :data="harvestSidebarData"
      :farms="farms"
      :factories="factories"
      :trucks="trucks"
      :operators="operators"
    />
    <div class="vx-col w-full">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-2/3">
          <vx-card class="mb-base">
            <div v-if="!farm" class="m-4">
              <skeleton-box height="40px" width="300px"></skeleton-box>

              <skeleton-box class="mt-6" height="20px"></skeleton-box>
              <skeleton-box class="mt-2" height="20px"></skeleton-box>
              <skeleton-box class="mt-2" height="20px"></skeleton-box>
              <skeleton-box class="mt-2" height="20px"></skeleton-box>
              <skeleton-box class="mt-2" height="20px"></skeleton-box>
              <skeleton-box class="mt-2" height="20px"></skeleton-box>
            </div>
            <div v-else class="m-4">
              <div class="flex flex-wrap justify-between">
                <div class="flex">
                  <h2>
                    <strong>{{ farm.a }}</strong>
                  </h2>
                  <vs-chip
                    class="text-white ml-4 text-sm h-2"
                    :class="`bg-success`"
                    ><span class="sd:none md:block hidden font-bold"
                      >Active</span
                    ></vs-chip
                  >
                </div>
                <div>
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-8 h-5 hover:text-primary stroke-current cursor-pointer"
                    @click="editData(farm)"
                  />
                  <vs-dropdown
                    vs-trigger-click
                    class="cursor-pointer hover:text-primary stroke-current"
                  >
                    <feather-icon
                      icon="MoreVerticalIcon"
                      svgClasses="w-8 ml-2 pr-3 h-5"
                    />
                    <vs-dropdown-menu class="w-100">
                      <vs-dropdown-item>
                        <div
                          @click="$router.push('/farms').catch(() => {})"
                          class="flex items-center"
                        >
                          <feather-icon
                            icon="PowerIcon"
                            class="inline-block mr-2"
                            svgClasses="w-4 h-4"
                          />
                          <span>Deactivate Farm</span>
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <span class="text-sm"
                >Located in <strong>{{ farm.b }}</strong></span
              >
              <div v-if="farm.h" class="mt-4">
                <strong>About Farm</strong><br />
                <span class="text-sm">{{ farm.h }}</span>
              </div>
              <div class="mt-4">
                <span><strong>Farm Type: </strong> {{ farm.d }}</span
                ><br />
                <span
                  ><strong>{{ farm.d }} Price: </strong> KES
                  {{ Number(farm.c).toLocaleString() }}</span
                ><br />
                <span
                  ><strong>Estimated m3: </strong>
                  {{ Number(farm.e).toLocaleString() }} m3</span
                ><br />
                <span
                  ><strong>Price per m3: </strong>KES
                  {{
                    Number((farm.c / farm.e).toFixed(2)).toLocaleString()
                  }}</span
                ><br />
                <span
                  ><strong>Acrerage: </strong>
                  {{ Number(farm.f).toLocaleString() }} acre{{
                    Number(farm.f) === 1 ? "" : "s"
                  }}</span
                >
                <br />
                <span
                  ><strong>Last Modified: </strong>
                  {{ parseDate(farm.g) }}</span
                >
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col w-full lg:w-1/3">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="ActivityIcon"
            icon-right
            :statistic="totalm3"
            statisticTitle="Total m3"
          />
          <statistics-card-line
            hideChart
            class="mb-base"
            :icon="
              `${
                totalm3ThisMonth > totalm3LastMonth
                  ? 'ArrowUpRightIcon'
                  : 'ArrowDownRightIcon'
              }`
            "
            :color="
              `${totalm3ThisMonth > totalm3LastMonth ? 'success' : 'danger'}`
            "
            icon-right
            :statistic="totalm3ThisMonth"
            :statisticTitle="`${months[getMonth]}'s m3`"
          />
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="ArchiveIcon"
            icon-right
            :statistic="totalm3LastMonth"
            :statisticTitle="`${months[getMonth - 1]}'s m3`"
            color="warning"
          />
        </div>
      </div>
    </div>

    <div class="vx-col w-full mb-base">
      <vx-card>
        <vs-tabs>
          <vs-tab label="Harvests">
            <div v-if="!harvestsF" class="m-4">
              <skeleton-box height="30px" width="200px"></skeleton-box>
              <skeleton-box class="mt-6 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
            </div>
            <div v-else class="m-4 mb-2">
              <vs-table
                ref="table"
                pagination
                :max-items="harvestsPerPage"
                search
                :data="harvestsF"
              >
                <div
                  slot="header"
                  class="flex flex-wrap-reverse items-center flex-grow justify-between"
                >
                  <div
                    class="flex flex-wrap-reverse items-center data-list-btn-container"
                  >
                    <!-- ADD NEW -->
                    <div
                      class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                      @click="addNewHarvestData"
                    >
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span class="ml-2 text-base text-primary">Add New</span>
                    </div>
                  </div>
                </div>

                <template slot="thead">
                  <vs-th sort-key="b">Factory</vs-th>
                  <vs-th sort-key="c">Truck</vs-th>
                  <vs-th sort-key="d">m3</vs-th>
                  <vs-th sort-key="h">Operator</vs-th>
                  <vs-th sort-key="e">Authorized by</vs-th>
                  <vs-th sort-key="f">Date</vs-th>
                  <!-- <vs-th>Action</vs-th> -->
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>
                        <p class="font-medium truncate">{{ tr.b.a }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">{{ tr.c.a }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="font-medium truncate">{{ tr.c.b }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{
                            tr.h
                              ? "a" in tr.h
                                ? tr.h.a
                                : "Operator N/A"
                              : "N/A"
                          }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ tr.e.b }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ parseDate(tr.f) }}
                        </p>
                      </vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <!-- <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-8 h-5 hover:text-primary stroke-current"
                  @click.stop="viewHarvest(tr._id)"
                /> -->
                        <!-- <feather-icon
                  icon="EditIcon"
                  svgClasses="w-8 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  v-show="false"
                  icon="TrashIcon"
                  svgClasses="w-8 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(tr.id)"
                /> -->
                      </vs-td>
                      <template class="expand-user" slot="expand">
                        <div class="con-expand-users w-full">
                          <vs-list>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-hash"
                              :title="tr._id"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-calendar"
                              :title="parseDate(tr.f)"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-hard-drive"
                              :title="`${tr.b.a} - ${tr.b.b}`"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-truck"
                              :title="`${tr.c.a} - ${tr.c.d}, ${tr.c.e}`"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-feather"
                              :title="`${tr.c.b || 0} m3`"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-user"
                              :title="tr.e.b"
                            ></vs-list-item>
                            <vs-list-item
                            icon-pack="feather"
                            icon="icon-tool"
                              :title="
                                tr.h
                                  ? 'a' in tr.h
                                    ? `Operator: ${tr.h.a} - ${tr.h.b}, ${tr.h.d}`
                                    : 'Operator N/A'
                                  : 'Operator N/A'
                              "
                            ></vs-list-item>
                            <vs-list-item
                              v-if="tr.d.length > 1"
                              icon-pack="feather"
                              icon="icon-info"
                              :title="tr.d"
                            ></vs-list-item>
                          </vs-list>
                        </div>
                      </template>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Expenses">
            <div v-if="!expensesF" class="m-4">
              <skeleton-box height="30px" width="200px"></skeleton-box>
              <skeleton-box class="mt-6 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
              <skeleton-box class="mt-4 w-full" height="30px"></skeleton-box>
            </div>
            <div v-else class="m-4 mb-2">
              <vs-table
                ref="table"
                pagination
                :max-items="expensesPerPage"
                search
                :data="expensesF"
              >
                <div
                  slot="header"
                  class="flex flex-wrap-reverse items-center flex-grow justify-between"
                >
                  <div
                    class="flex flex-wrap-reverse items-center data-list-btn-container"
                  >
                    <!-- ADD NEW -->
                    <div
                      class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                      @click="addNewExpense"
                    >
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span class="ml-2 text-base text-primary">Add New</span>
                    </div>
                  </div>
                </div>

                <template slot="thead">
                  <vs-th sort-key="e">Type</vs-th>
                  <vs-th sort-key="c">Category</vs-th>
                  <vs-th sort-key="d">Sub Category</vs-th>
                  <vs-th sort-key="a">Amount</vs-th>
                  <vs-th sort-key="b">Description</vs-th>
                  <vs-th sort-key="f">User</vs-th>
                  <vs-th sort-key="g">Date</vs-th>
                  <vs-th v-if="$acl.check('admin')">Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>
                        <p class="font-medium truncate">
                          <vs-chip
                            class="text-white"
                            :class="
                              `bg-${tr.e === 'Asset' ? 'success' : 'danger'}`
                            "
                            >{{ tr.e }}</vs-chip
                          >
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ tr.c }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ tr.d.b || tr.d }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          KES {{ Number(tr.a).toLocaleString() }}
                        </p>
                      </vs-td>
                      <vs-td>
                        <p class="font-medium truncate">
                          {{ tr.b }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ tr.f ? tr.f.b : "N/A" }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">
                          {{ parseDate(tr.g) }}
                        </p>
                      </vs-td>

                      <vs-td
                        v-if="$acl.check('admin')"
                        class="whitespace-no-wrap"
                      >
                        <feather-icon
                          icon="EditIcon"
                          svgClasses="w-8 h-5 hover:text-primary stroke-current"
                          @click.stop="editExpensesData(tr)"
                        />
                        <!-- <feather-icon
                v-show="false"
                icon="TrashIcon"
                svgClasses="w-8 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.id)"
              /> -->
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Report">
            <vs-tabs>
              <vs-tab label="Expenses">
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/2">
                    <vx-card class="mb-base">
                      <e-charts
                        autoresize
                        :options="pie"
                        ref="pie"
                        auto-resize
                      />
                    </vx-card>
                  </div>
                  <div class="vx-col w-full lg:w-1/2">
                    <vx-card class="mb-base">
                      <vue-apex-charts
                        type="bar"
                        height="350"
                        :options="chartOptions"
                        :series="series"
                      ></vue-apex-charts>
                    </vx-card>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import ExpensesDataViewSidebar from "../expenses/DataViewSidebar.vue";
import HarvestsDataViewSidebar from "../harvest/DataViewSidebar.vue";
import SkeletonBox from "@/components/SkeletonBox.vue";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
import VueApexCharts from "vue-apexcharts";

import p from "@/db/pouch";
import { months } from "moment";

export default {
  components: {
    SkeletonBox,
    DataViewSidebar,
    ExpensesDataViewSidebar,
    HarvestsDataViewSidebar,
    StatisticsCardLine,
    ECharts,
    VueApexCharts,
  },
  data() {
    return {
      farm: null,
      harvests: null,
      expenses: null,
      plantations: null,
      npl: false,
      pl: {},

      farms: [],
      trucks: [],
      factories: [],
      operators: [],

      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},

      addNewHarvestSidebar: false,
      harvestSidebarData: {},
      harvestsPerPage: 10,

      addNewExpenseSidebar: false,
      expenseSidebarData: {},
      expensesPerPage: 10,
      date: new Date(),
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],

      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#28C76F", "#EA5455"],
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        yaxis: {
          title: {
            text: "Kenya Shillings",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return "KES " + Number(val).toLocaleString();
            },
          },
        },
      },

      pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} ({d}%)", // c > plain value
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: [],
        },
        series: [
          {
            name: "Expenses",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            color: ["#28C76F", "#EA5455"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  pouch: {
    farmData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { _id: this.$route.params.id, z: 6 },
      };
    },
    harvestData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 9 },
      };
    },
    expenseData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 7 },
      };
    },
    farmsData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 6 },
      };
    },
    factoryData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 5 },
      };
    },
    truckData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 2 },
      };
    },
    operatorData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 3 },
      };
    },
  },
  watch: {
    farmData(v) {
      if (v.length === 1) this.decrypt("farm", v[0], "f");
    },
    harvestData(v) {
      this.decrypt("harvests", v, "f");
    },
    expenseData(v) {
      this.decrypt("expenses", v, "f");
    },
    farmsData(v) {
      this.decrypt("farms", v);
    },
    factoryData(v) {
      this.decrypt("factories", v);
    },
    truckData(v) {
      this.decrypt("trucks", v);
    },
    operatorData(v) {
      this.decrypt("operators", v);
    },
  },
  computed: {
    expensesF() {
      if (!(this.expenses instanceof Array)) return [];
      let eF = this.expenses.filter((e) => e.h._id === this.$route.params.id);
      this.calculateExpenses(eF);
      return eF;
    },
    harvestsF() {
      if (!(this.harvests instanceof Array)) return [];
      return this.harvests.filter((e) => e.a._id === this.$route.params.id);
    },
    getMonth() {
      return this.date.getMonth();
    },
    pvalid() {
      return (
        !this.errors.any() &&
        this.pl.identity !== "" &&
        this.pl.acreage !== "" &&
        this.pl.m3 !== ""
      );
    },
    totalm3() {
      if (this.harvestsF === null || this.harvestsF.length === 0) return 0;
      let count = 0;
      this.harvestsF.map((harvest) => {
        count = count + (parseInt(harvest.c.b) || 0);
      });
      return count;
    },
    totalm3ThisMonth() {
      if (this.harvestsF === null || this.harvestsF.length === 0) return 0;
      var firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
      var lastDay = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        0
      );
      let count = 0;
      this.harvestsF.map((harvest) => {
        if (harvest.f >= firstDay.getTime() && harvest.f <= lastDay.getTime()) {
          count = count + (parseInt(harvest.c.b) || 0);
        }
      });
      return count;
    },
    totalm3LastMonth() {
      if (this.harvestsF === null || this.harvestsF.length === 0) return 0;
      var firstDay = new Date(
        this.date.getFullYear(),
        this.date.getMonth() - 1,
        1
      );
      var lastDay = new Date(this.date.getFullYear(), this.date.getMonth(), 0);
      let count = 0;
      this.harvestsF.map((harvest) => {
        if (harvest.f >= firstDay.getTime() && harvest.f <= lastDay.getTime()) {
          count = count + (parseInt(harvest.c.b) || 0);
        }
      });
      return count;
    },
    currentExpensePage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.expensesF.length;
    },
  },
  methods: {
    getFirstDayofMonth(month) {
      return new Date(this.date.getFullYear(), month, 1);
    },
    calculateExpenses(data) {
      this.series = [];
      this.pie.series[0].data = [];
      let te = 0;
      let ae = 0;
      let le = 0;
      let tec = [];
      let tec2 = [];
      this.months.map((month, i) => {
        tec[i] = {
          x: month,
          y: 0,
        };
        tec2[i] = {
          x: month,
          y: 0,
        };
      });

      data.map((expense) => {
        let ed = new Date(expense.g);
        te = te + parseInt(expense.a);
        switch (expense.e) {
          case "Asset":
            ae = ae + parseInt(expense.a);
            tec[ed.getMonth()].y =
              parseInt(tec[ed.getMonth()].y) + parseInt(expense.a);
            break;

          case "Liability":
            le = le + parseInt(expense.a);
            tec2[ed.getMonth()].y =
              parseInt(tec2[ed.getMonth()].y) + parseInt(expense.a);
            break;
          // Skip the rest
        }
      });

      this.series.push({
        name: "Asset",
        data: tec,
      });
      this.series.push({
        name: "Liability",
        data: tec2,
      });

      this.pie.series[0].data.push({
        value: ae,
        name: `Assets KES ${Number(ae).toLocaleString()}`,
      });
      this.pie.series[0].data.push({
        value: le,
        name: `Liability KES ${Number(le).toLocaleString()}`,
      });
    },
    async decrypt(k, v, dk) {
      this.loading = true;
      this[k] = await p.de(v);
      this.sortData(this[k], dk);
      this.loading = false;
    },
    sortData(data, key) {
      if (this[data] instanceof Array)
        this[data].sort(function(a, b) {
          var keyA = new Date(a[key]),
            keyB = new Date(b[key]);
          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
      return this[data];
    },
    cancelPlantation() {
      this.newplantation = false;
    },
    savePlantation() {
      this.newplantation = false;
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true, "addNewDataSidebar");
    },
    editExpensesData(data) {
      this.expenseSidebarData = data;
      this.toggleDataSidebar(true, "addNewExpenseSidebar");
    },
    parseDate(d) {
      return this.$moment(d).format("dddd, MMMM Do YYYY h:mm a");
    },
    toggleDataSidebar(val = false, type) {
      this[type] = val;
    },
    closeFarmSidebar(val) {
      this.toggleDataSidebar(val, "addNewDataSidebar");
    },
    closeExpensesSidebar(val) {
      this.toggleDataSidebar(val, "addNewExpenseSidebar");
    },
    closeHarvestsSidebar(val) {
      this.toggleDataSidebar(val, "addNewHarvestSidebar");
    },
    addNewExpense() {
      this.expenseSidebarData = {
        h: this.farm, // Leave as one key
      };
      this.toggleDataSidebar(true, "addNewExpenseSidebar");
    },
    addNewHarvestData() {
      this.harvestSidebarData = {
        a: {
          label: `${this.farm.a} - ${this.farm.b}`,
          value: this.farm,
        },
      };
      this.toggleDataSidebar(true, "addNewHarvestSidebar");
    },
  },
  created() {},
};
</script>
